export type BookingScope = {
  bookingId: string;
  invoiceId?: never;
};

export type InvoiceScope = {
  invoiceId: string;
  bookingId?: never;
};

export type AnyBookingScope = {
  anyBooking: true;
  bookingId?: never;
  invoiceId?: never;
};

export type BookingOrInvoiceScope = BookingScope | InvoiceScope;

export type AllocationScope = BookingOrInvoiceScope | AnyBookingScope;

export const isAnyBookingScope = (scope: AllocationScope): scope is AnyBookingScope =>
  'anyBooking' in scope && scope.anyBooking === true;

export const isBookingScope = (scope: AllocationScope): scope is BookingScope =>
  !isAnyBookingScope(scope) && scope.bookingId !== undefined;
